import React from "react";
import { useAppSelector, useAppDispatch } from "../store";
import {
  selectors,
} from "../store/selectors/shipBuilderSelectors";
import {
  toggleOverrideTechLevel,
  toggleOverrideWeight,
  toggleOverrideSize,
  toggleOverridePower,
  toggleOverrideAllRestrictions,
} from "../store/features/shipBuilderSlice";
import { DebugButton } from "./DebugButton";
import { DarkModeToggleWithLabel } from "./shared/DarkModeToggle";

const SettingsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const overrideTechLevel = useAppSelector(selectors.selectOverrideTechLevel);
  const overrideWeight = useAppSelector(selectors.selectOverrideWeight);
  const overrideSize = useAppSelector(selectors.selectOverrideSize);
  const overridePower = useAppSelector(selectors.selectOverridePower);
  const overrideAll = useAppSelector(selectors.selectOverrideAllRestrictions);

  return (
    <div className="max-w-xl mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow border dark:border-gray-700 mt-8">
      <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100">Settings</h2>
      
      {/* Theme Settings */}
      <div className="mb-8 pb-6 border-b border-gray-300 dark:border-gray-600">
        <h3 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-200">Appearance</h3>
        <DarkModeToggleWithLabel />
      </div>

      <div className="space-y-4">
        <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={overrideTechLevel || overrideAll}
            disabled={overrideAll}
            onChange={() => dispatch(toggleOverrideTechLevel())}
            className="rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700"
          />
          Override TL limitations
        </label>
        <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={overrideWeight || overrideAll}
            disabled={overrideAll}
            onChange={() => dispatch(toggleOverrideWeight())}
            className="rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700"
          />
          Override weight limitations
        </label>
        <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={overrideSize || overrideAll}
            disabled={overrideAll}
            onChange={() => dispatch(toggleOverrideSize())}
            className="rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700"
          />
          Override size limitations
        </label>
        <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={overridePower || overrideAll}
            disabled={overrideAll}
            onChange={() => dispatch(toggleOverridePower())}
            className="rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700"
          />
          Override power limitations
        </label>
        <label className="flex items-center gap-2 font-semibold text-blue-700 dark:text-blue-400">
          <input
            type="checkbox"
            checked={overrideAll}
            onChange={() => dispatch(toggleOverrideAllRestrictions())}
            className="rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700"
          />
          Override all restrictions
        </label>
      </div>
      
      <div className="mt-8 pt-6 border-t border-gray-300 dark:border-gray-600">
        <h3 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-200">Developer Tools</h3>
        <DebugButton />
      </div>
    </div>
  );
};

export default SettingsPage; 